import { render, staticRenderFns } from "./RoleName.vue?vue&type=template&id=769d7226&"
import script from "./RoleName.vue?vue&type=script&lang=js&"
export * from "./RoleName.vue?vue&type=script&lang=js&"
import style0 from "./RoleName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports